import React, { useState } from 'react';

const BACKEND_URL = 'https://web3-pos-v2.gdbok.workers.dev';

export const MerchantLogin = ({ onLoginSuccess, onSwitchToRegister }) => {
  const [walletAddress, setWalletAddress] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validateWallet = (address) => {
    return /^0x[a-fA-F0-9]{40}$/.test(address);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!validateWallet(walletAddress)) {
      setError('Invalid wallet address');
      return;
    }

    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/merchant/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          walletAddress: walletAddress.trim(),
          password
        })
      });

      const result = await response.json();

      if (!response.ok) {
        setError(result.error || 'Login failed');
        setLoading(false);
        return;
      }

      if (result.success) {
        localStorage.setItem('merchant_session', result.sessionToken);
        localStorage.setItem('merchant_wallet', result.wallet);
        onLoginSuccess(result);
      } else {
        setError('Login failed');
      }

    } catch (err) {
      console.error('Login error:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      maxWidth: '420px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '8px' }}>
          🏪 Merchant Panel
        </h1>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>
          Login to manage your payment tokens
        </p>
      </div>

      <form onSubmit={handleLogin}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            marginBottom: '6px',
            color: '#374151'
          }}>
            Wallet Address
          </label>
          <input
            type="text"
            placeholder="0x..."
            value={walletAddress}
            onChange={(e) => setWalletAddress(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '14px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontFamily: 'monospace',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            marginBottom: '6px',
            color: '#374151'
          }}>
            Password
          </label>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: '14px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {error && (
          <div style={{
            background: '#fee2e2',
            color: '#991b1b',
            padding: '10px 12px',
            borderRadius: '8px',
            fontSize: '13px',
            marginBottom: '16px',
            border: '1px solid #fecaca'
          }}>
            ⚠️ {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '15px',
            fontWeight: '600',
            background: loading ? '#9ca3af' : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: loading ? 'not-allowed' : 'pointer',
            marginBottom: '12px'
          }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>

        <button
          type="button"
          onClick={onSwitchToRegister}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '14px',
            fontWeight: '500',
            background: 'white',
            color: '#6366f1',
            border: '1px solid #6366f1',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Create New Account
        </button>
      </form>
    </div>
  );
};

export default MerchantLogin;